import React, { Component } from "react";
import DataTable from "../../../Datatable/DataTable";
import WithCard from "../../../../../common/withCard";

class TableHolder extends Component {
  state = {
    heading: [{ title: "Style Exposure" }, { title: `Weight (%)` }],
    data: []
  };
  componentDidMount() {
    let { TreeData } = this.props;
    let data = this.renderTable(TreeData);

    this.setState({
      data
    });
  }
  componentWillReceiveProps(nextProps) {
    let { TreeData } = nextProps;

    if (JSON.stringify(TreeData) !== JSON.stringify(this.props.TreeData)) {
      let data = this.renderTable(TreeData);

      this.setState({
        data
      });
    }
  }
  renderTable = TreeData => {
    var Data1 = [];
    if (Object.keys(TreeData).length > 0) {
      for (let i = 0; i < Object.keys(TreeData).length; i++) {
        Data1.push([
          Object.keys(TreeData)[i],
          Object.values(TreeData)[i].toFixed(2)
        ]);
      }
      Data1.sort((a, b) => (a[1] < b[1] ? -1 : a[1] > b[1] ? 1 : 0));
      return Data1;
    }
  };

  render() {
    const { data, heading } = this.state;
    return (
      <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
        <WithCard>
          {data.length > 0 ? (
            <DataTable
              data={data}
              columns={heading}
              paging={false}
              searching={false}
              scrollX={true}
            />
          ) : null}
        </WithCard>
      </div>
    );
  }
}

export default TableHolder;



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/Component page/LiveAsset/section2/tableHolder.jsx